var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CloudPictureBanner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('CloudPictureTitle'),_c('CloudPictureContent'),_c('CloudPictureBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }